import { getUserManagementModuleName } from './user-management.permissions';
import { AccountsPermissions } from './accounts.permissions';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { PermissionEnum } from '../../../common/permissions/permissions.Enum';

export class AccountsUsersPermissions {
    static GroupName = `${AccountsPermissions.GroupName}.Users`;

    static getPermissions = getGroupPermissionFactory(AccountsUsersPermissions.GroupName);

    static Permissions = {
        Create: AccountsUsersPermissions.getPermissions(PermissionEnum.CREATE),
        Read: AccountsUsersPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: AccountsUsersPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: AccountsUsersPermissions.getPermissions(PermissionEnum.UPDATE),
        ChangePassword: AccountsUsersPermissions.getPermissions('ChangePassword')
    };
}
